import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loading from "../../components/Loading"
import TemplateDefault from "../Templates/Default";

import API from "../../api";
import { translate } from "../../translate";

import "./style.css";
//import imgBG from "../../../assets/images/bg-full.jpg";

class LeadsDisponiveis extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            loading: false,
            errors: [],
            tableCollunsName: [],
            leads: [],
            leads_filtered: null,
            lead: null,
            meusLeadsIds: [],
            filter: {}
        };

       // API.setImageBackground(imgBG);
    }

    composer = ( ...fns ) => value => fns.length ? fns.reduceRight( ( previousValue, fn ) => fn( previousValue ), value ) : value;

    openNewWindow = url => {
        let self = this;
        var new_window = window.open( url, "_blank" )
        new_window.onunload = function () {
            self.filter()
        }
    }

    componentDidMount() {
        this.init();


    }

    init = () => {
        let self = this;
        this.getLeads();

        //init scripts
        window.jQuery( '.input-daterange' ).datepicker( {
            format: 'dd/mm/yyyy',
            autoclose: true,
        } ).on( 'changeDate', function ( e ) {

            self.setState( state => {
                state.filter[e.target.name] = `${e.target.value.split( "/" )[2]}-${e.target.value.split( "/" )[1]}-${e.target.value.split( "/" )[0]} 00:00:00`;
                return state;
            } )

        } );
    }

    apropriar = lead => {
        let { id, dataapropriacao, idusuario, estagio } = lead;

        idusuario = this.props.activeUser.id;
        estagio = "T";
        //eslint-disable-next-line
        dataapropriacao = new Date().toISOString().match( /(^[0-9]{4}\-[0-9]{2}\-[0-9]{2})/ )[0];


        this.setApropria( id, dataapropriacao, idusuario, estagio ).then( async ( r ) => {
            let d = [{ title: "", message: r, type: "success" }]

            this.props.dispatch( { type: 'NOTIFY', payload: d } );


            await this.filter()

        } );

    }

    getLeads = () => {
        return new Promise( ( resolve, reject ) => {
            this.setState( {
                errors: [],
                loading: true
            } );

            API.get( "/leads" ).then( async r => {
                let tableNames = [];
                let data = Object.values( r.data );
                data = data.map( d => {
                    if ( d.estagio ) d.estagio = translate( d.estagio );
                    return d;
                } );

                //Removendo Meus Leads dessa lista
                await this.getMeusLeads()
                data = data.filter( d => !!!this.state.meusLeadsIds.includes( d.id ) )

                if ( data[0] ) {
                    tableNames = Object.keys( data[0] );
                }

                this.setState( state => {

                    state.errors = data.length === 0  ? [{ type: "alert-warning", msg: translate("Nenhum resultado encontrado") }] : [];

                    state.leads = data;
                    state.tableCollunsName = tableNames;
                    state.loading = false;


                    return state;
                } );

                this.setFilter( {
                    nomes: data.map( d => d.nome || null ).filter( ( elem, index, self ) => elem != null && index === self.indexOf( elem ) ).sort(),
                    destinos: data.map( d => d.destino || null ).filter( ( elem, index, self ) => elem != null && index === self.indexOf( elem ) ).sort(),
                    estagios: data.map( d => d.estagio || null ).filter( ( elem, index, self ) => elem != null && index === self.indexOf( elem ) ).sort(),
                } )

                resolve( data )

            }, error => {
                let errors = [{ type: "alert-danger", msg: "Não foi possivel carregar os leads nesse momento..." }];

                this.setState( {
                    leads: [],
                    errors: errors,
                    loading: false
                } );
                reject( errors )
            } )
        } )

    }

    getMeusLeads = () => {
        return new Promise( ( resolve, reject ) => {
            API.post( "/meusleads", { idusuario: this.props.activeUser.id } ).then( r => {
                let data = Object.values( r.data );


                this.setState( {
                    meusLeadsIds: data.map( d => d.id ),
                    loading: false
                } );

                resolve( data )

            }, error => {
                //let errors = [{ type: "alert-danger", msg: "Nenhum resultado encontrado..." }];

                this.setState( {
                    //errors: errors,
                    meusLeadsIds: [],
                    loading: false
                } );

                resolve( [] )
            } )

        } )

    }

    setApropria = ( id, dataapropriacao, idusuario, estagio ) => {

        return new Promise( ( resolve, reject ) => {
            this.setState( {
                errors: [],
                loading: true,
                idLead: id
            } );

            API.put( "/apropria", { id, dataapropriacao, idusuario, estagio } ).then( r => {
                let data = Object.values( r.data )[0];

                this.setState( {
                    loading: false
                } );

                resolve( data )


            }, error => {
                let errors = [{ type: "alert-danger", msg: "Não foi possivel carregar o lead nesse momento..." }];

                this.setState( {
                    errors: errors,
                    loading: false
                } );

                reject( errors )
            } )



        } )
    }

    selectLead( lead ) {

        this.setState( {
            lead: lead
        } )
    }

    resetFilter = () => {

        this.setState( state => {

            state.filter = Object.assign(
                this.state.filter,
                {
                    data_final: null,
                    data_inicio: null,
                    nome: null,
                    destino: null,
                    estagio: null
                },
            )
            state.lead = null;
            state.errors = [];
            state.loading = true
            return state
        } )

        new Promise( resolve => this.filter() ).then( r => {
            this.setState( {
                leads_filtered: null,
                loading: false
            } )
        } )

    }

    setFilter = ( ops ) => {
        this.setState( state => {
            state.filter = Object.assign(
                this.state.filter,
                ops
            )

            return state;
        } )

    }

    filter = () => {
        let self = this;
        let filter_here = {}

        self.setState( {
            lead : null
        });

        return new Promise( async ( resolve, reject ) => {

            let leads = await this.getLeads();
            filter_here = self.state.filter;
            resolve( leads )

        } ).then( ( leads ) => {
            self.setState( {
                errors: [],
                loading: true
            } );


            let filter_nome = arr => filter_here.nome ? ( arr.filter( a => a.nome && a.nome.toLowerCase().indexOf( filter_here.nome.toLowerCase() ) > -1 ) ) : arr;
            let filter_destino = arr => filter_here.destino ? ( arr.filter( a => a.destino && a.destino.toLowerCase().indexOf( filter_here.destino.toLowerCase() ) > -1 ) ) : arr;
            let filter_estagio = arr => filter_here.estagio ? arr.filter( a => a.estagio && a.estagio === filter_here.estagio ) : arr;
            let filter_data_inicio = arr => filter_here.data_inicio ? arr.filter( a => ( new Date( `${a.dataentrada} 00:00:00` ).getTime() ) >= ( new Date( `${filter_here.data_inicio}` ).getTime() ) ) : arr;
            let filter_data_final = arr => filter_here.data_final ? arr.filter( a => ( new Date( `${a.dataentrada} 00:00:00` ).getTime() ) <= ( new Date( `${filter_here.data_final}` ).getTime() ) ) : arr;

            let filtered = self.composer(
                filter_nome,
                filter_destino,
                filter_estagio,
                filter_data_inicio,
                filter_data_final
            )( leads )


            return filtered;


        } ).then( r => {
            let errors = [];


            if ( r && r.length === 0 ) {
                errors.push( {
                    type: "alert-warning",
                    msg: translate( "Nenhum resultado foi encontrado..." )
                } )
            }

            self.setState( {
                leads_filtered: r,
                errors,
                loading: false
            } )
        } )


    }

    fields_excepts = ( fields ) => {
        let fields_except = ["id", "dataentrada", "estagio", "nome", "destino", "dataviagemprevista"];

        if ( fields.length ) {
            //eslint-disable-next-line
            fields = fields.map( field => {
                //eslint-disable-next-line  
                Object.keys( field ).map( field_name => {
                    if ( !fields_except.includes( field_name ) ) delete field[field_name]
                } )
                return field
            } )

            return fields
        }

        return fields;
    }

    format_fields = fields => {

        if ( Array.isArray( fields ) ) {
            return fields.map( f => {
                //eslint-disable-next-line
                if ( f.hasOwnProperty( "dataentrada" ) && RegExp( /(^[0-9]{4}\-[0-9]{2}\-[0-9]{2})/g ).test( f["dataentrada"] ) ) f["dataentrada"] = new Date( `${f["dataentrada"]} 00:00:00` ).toLocaleDateString()
                //eslint-disable-next-line
                if ( f.hasOwnProperty( "estagio" ) && Boolean( !!!f["estagio"] || f["estagio"] === "L" ) ) f["estagio"] = translate( "A" ); // defininindo estagio como aberto quando vazio ou null
                // if (f.hasOwnProperty("estagio") && f["estagio"]) f["estagio"] = translate(f["estagio"])
                return f;
            } );
        }

        return fields
    }

    render() {
        let leads_filtered = this.state.leads_filtered ? this.state.leads_filtered : this.state.leads;
        leads_filtered = this.composer(
            this.fields_excepts,
            this.format_fields
        )( leads_filtered )

        let tableCollunsName = this.composer(
            Object.keys
        )( leads_filtered.length ? leads_filtered[0] : [] )

        return (
            <TemplateDefault>
                <div id="leads-disponiveis">
                    <h4 style={{ "marginTop": "0" }}>{translate( "Leads Disponíveis" )}</h4>
                    <hr />

                    <div className="body_bottom">

                        <div className="body-filter">
                            <form onSubmit={e => e.preventDefault()} className={`form-filter`} autoComplete={"off"}>

                                <div className="col-sm-12">
                                    <div className="row">
                                        <div className="col-sm-10">
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <div className="row input-daterange form-group">
                                                        <div className="col-sm-6 col-xs-6">
                                                            <label htmlFor="sel00">{translate( "Data inicial" )}:</label>
                                                            <div className="input-group date" >

                                                                <input autoComplete={"off"} name="data_inicio" placeholder="dd/mm/aaaa" id="sel00" type="text" className="form-control" />
                                                                <div className="input-group-addon">
                                                                    <span className="glyphicon glyphicon-calendar"></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-xs-6">
                                                            <label htmlFor="sel01">{translate( "Data final" )}:</label>
                                                            <div className="input-group date" >

                                                                <input autoComplete={"off"} name="data_final" placeholder="dd/mm/aaaa" id="sel01" type="text" className="form-control" />
                                                                <div className="input-group-addon">
                                                                    <span className="glyphicon glyphicon-calendar"></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-sm-6">
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label htmlFor="sel01">{translate( "Nome" )}:</label>

                                                                <input onChange={e => this.setFilter( { nome: e.target.value } )} className="form-control" placeholder={translate( "Todos os nomes" )} list="nomes" name="nomes" id="sel01" />
                                                                <datalist id="nomes">
                                                                    {
                                                                        this.state.filter.nomes && this.state.filter.nomes.map( ( d, k ) => {

                                                                            return (
                                                                                <option key={k} value={d} />
                                                                            )
                                                                        } )
                                                                    }
                                                                </datalist>

                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label htmlFor="sel1">{translate( "Destino desejado" )}:</label>

                                                                <input autoComplete="off" onChange={e => this.setFilter( { destino: e.target.value } )} className="form-control" placeholder={translate( "Todos dos destinos" )} list="destinos" name="destinos" id="sel1" />
                                                                <datalist id="destinos">
                                                                    {
                                                                        this.state.filter.destinos && this.state.filter.destinos.map( ( d, k ) => {

                                                                            return (
                                                                                <option key={k} value={d} />
                                                                            )
                                                                        } )
                                                                    }
                                                                </datalist>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                              
                                                
                                                <div className="col-sm-2">
                                                    <div className="form-group">
                                                        <label htmlFor="sel0">{translate( "Status do Lead" )}:</label>
                                                        <select className="form-control" id="sel0" defaultValue={this.state.filter.estagios} onChange={e => this.setFilter( { estagio: e.target.value } )}>
                                                            <option defaultChecked value="">{translate( "Todos" )}</option>
                                                            {
                                                                this.state.filter.estagios && this.state.filter.estagios.map( ( d, k ) => {

                                                                    return (
                                                                        <option key={k} value={d}>{d}</option>
                                                                    )
                                                                } )
                                                            }
                                                        </select>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-sm-2 col-xs-12">
                                            <div className="desktop" style={{ marginTop: "25px" }}></div>
                                            <div className="row">
                                                <div className="col-sm-6 col-xs-6">
                                                    <button onClick={e => this.resetFilter()} className="btn btn-mobile btn-block btn-default" type="reset" style={{ "marginRight": "5px" }}>Limpar</button>
                                                </div>
                                                <div className="col-sm-6 col-xs-6">
                                                    <button onClick={e => this.filter()} className="btn btn-mobile btn-block btn-primary" > <span className="glyphicon glyphicon-filter"></span> Filtrar</button>
                                                </div>


                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </form>
                            <div className="clearfix"></div>
                            <hr />
                        </div>


                        <div className={`table-responsive table1  ${!!!leads_filtered.length || this.state.loading ? "hide" : ""} `}>

                            <table className="table table-bordered">
                                <thead style={{ "backgroundColor": "#cecece5c" }}>
                                    <tr>
                                        {
                                            tableCollunsName.map( ( h, i ) => (
                                                <th key={i}>{translate( h )}</th>
                                            ) )
                                        }
                                    </tr>
                                </thead>
                                <tbody>

                                    {
                                        leads_filtered.map( ( h, i ) => (
                                            <tr key={i} onClick={() => this.selectLead( h )} className={this.state.lead && this.state.lead.id === h.id ? "selected" : ""} >
                                                {
                                                    Object.values( h ).map( ( b, j ) => (
                                                        <td key={j} style={j === 0 ? { "backgroundColor": "#cecece5c", "fontWeight": "bold" } : {}} title={Object.keys( h )[j]}>{b}</td>
                                                    ) )
                                                }

                                            </tr>
                                        ) )
                                    }

                                </tbody>
                            </table>


                        </div>
                        <div className={`row ${!!!this.state.errors.length ? "hide" : ""}`}>
                            <div className="col-sm-12">
                                {
                                    this.state.errors.map( ( error, index ) => {
                                        return (
                                            <div key={index} className={`alert ${error.type || 'alert-danger'} mt-20`}>
                                                <b> <i className="glyphicon glyphicon-alert"></i>  {translate( error.msg )} </b>
                                            </div>
                                        );
                                    } )
                                }

                            </div>
                        </div>

                        {
                            !!!this.state.loading ? "" : (
                                <div className="body-white">
                                    <div className="row area-loading mt-20 mb-20">
                                        <div className="col-sm 12 text-center">
                                            <Loading /> <span style={{ "fontSize": "20px", "margin": "20px" }}> {translate( "Carregando..." )}</span>
                                        </div>
                                    </div>
                                </div>

                            )

                        }

                        <hr />
                        <div className="row">
                        <div className={`col-sm-3 col-xs-12 pull-left mb-20 ${ this.state.loading ? "hide" : "" }`}>
                                <small>{translate("Total")}: { leads_filtered.length }</small>
                            </div>
                            <div className="col-sm-3 col-xs-6 pull-right">
                                <button onClick={e => this.openNewWindow( `/lead/${this.state.lead && this.state.lead.id}` )} disabled={!!!this.state.lead} className="btn btn-mobile btn-block btn-success" style={{ "marginBottom": "10px" }}> {translate( "Visualizar cadastro" )} </button>
                            </div>
                            <div className="col-sm-3 col-xs-6 pull-right">
                                <button disabled={!!!this.state.lead} onClick={f => this.apropriar( this.state.lead )} className="btn btn-mobile btn-block btn-primary"> {translate( "Apropriar do Lead" )} </button>
                            </div>
                        </div>
                    </div>



                </div>
            </TemplateDefault >

        )
    }
}

function matchDispatchToProps( dispatch ) {
    return {
        dispatch,
        //...bindActionCreators({selectUser: selectUser}, dispatch)
    };
}
// "state" is set in reducers/index.js
function mapStateToProps( state ) {
    return {
        activeUser: state.activeUser
    };
}

export default connect( mapStateToProps, matchDispatchToProps )( LeadsDisponiveis );